<template>
  <div class="resourceNew">
    <el-tabs v-model="currentTab" class="top-tabs">
      <el-tab-pane
        v-for="(item, index) in tabData.filter((x) => x.show)"
        :key="index"
        :label="item.GroupTypeName"
        :name="item.GroupTypeCode"
      >
        <component
          :ref="'tab' + currentTab"
          v-if="item.GroupTypeCode == currentTab"
          :is="currentComponent"
          v-model:groupTypeCode.sync="currentTab"
          v-model:itemParam.sync="itemParam"
          :isDialog="isDialog"
          @handle-confirm="handleConfirm"
          @handle-close="handleClose"
          @handle-cancel="handleCancel"
        ></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import resourceList from "@comp/Resource/resourceList.vue";
export default {
  name: "resourceNew",
  data() {
    return {
      tabData: [
        { GroupTypeCode: "1", GroupTypeName: "图片", show: true },
        { GroupTypeCode: "2", GroupTypeName: "视频", show: true },
        { GroupTypeCode: "3", GroupTypeName: "文档", show: true },
        { GroupTypeCode: "4", GroupTypeName: "图标", show: true },
      ],
      currentTab: "1",
      itemParam: {
        type: ["1", "2", "3", "4"], //显示的类型
        selectId: [], //选中的资源的id集合,
        isSingle: false, //是否单选
        source: "ResourceCenter", //文件来源
        row: {}, //操作行的对象
        sourceItem: {}, //资源文件对象
      },
    };
  },
  props: {
    isDialog: Boolean,
  },
  components: {
    resourceList: resourceList,
  },
  async mounted() {
    var that = this;
    await that.getTabs();
  },
  created() {},
  methods: {
    loading(param) {
      this.itemParam = param;
      this.tabData.forEach((x) => {
        x.show = true;
        if (param.type.indexOf(x.GroupTypeCode) == -1) x.show = false;
      });
      this.currentTab = param.selectFileType;
      this.$nextTick(() => {
        if (this.$refs["tab" + this.currentTab] != null)
          this.$refs["tab" + this.currentTab][0].getresourceList();
      });
    },
    handleConfirm(obj) {
      this.$emit("handle-confirm", obj);
    },
    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    //加载上面的大菜单
    async getTabs() {
      var that = this;
      that.checkTabQX();
    },
    //Tab权限校验
    checkTabQX() {
      let that = this;
      if (that.tabData.length > 0) {
        that.currentTab = that.tabData[0].GroupTypeCode;
      }
    },
  },
  computed: {
    currentComponent() {
      switch (this.currentTab) {
        default:
          return "resourceList";
      }
    },
  },
};
</script>
<style scoped>
.resourceNew {
  background-color: #fff;
  padding: 0 10px 10px 10px;
  height: 100%;
}
.top-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.resourceNew .top-tabs >>> .el-tabs__nav-scroll {
  margin-left: 20px;
}
.resourceList {
  height: 100%;
}
:deep(.el-tabs__content) {
  flex: 1;
}
:deep(.el-tab-pane) {
  height: 100%;
}
</style>